
import Template from 'components/templates/Sections.vue'
import Sections from 'components/mixins/Sections.vue'

import Subsections from 'components/globalBlocks/SubSections.vue'

export default {
  block: 'sections',
  mixins: [
    Template,
    Sections
  ],
  components: {
    Subsections
  },
}



// WEBPACK FOOTER //
// ./components/globalBlocks/Sections.vue